<template lang="pug">
v-chip.ma-0(v-if="show", small, :label="label", :class="['lb-info', 'lb-primary'][cardapio_digital ? 0 : 1]", style="font-size:9px").white--text.font-weight-bold {{cardapio_digital ? 'Cardápio Digital' : 'Bigou Delivery'}}
</template>

<script>
import _ from 'lodash';

export default {
  components: {
  },
  props: {
    cardapio_digital: {
      type: Boolean,
      default: false
    },
    label: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
    }
  },
  computed: {
    show(){
      return this.$root.showOrigemPedido();
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
